import { List } from "immutable";
import * as React from "react";
import * as BS from "react-bootstrap";
import * as Comp from "../../../../components";
import { Paths } from "../../../../constants";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";
import { DateHelper, Utility } from "../../../../utils";

interface OwnProps {
    abstracts: List<M.Abstract.Abstract>;
    api: Api;
    event: M.Event.Event;
    onResponseUpdated: (a: M.Abstract.Abstract, invitationResponseId: number) => void;
    onUpdateFailed: (a: M.Abstract.Abstract, errors: string[]) => void;
}

interface OwnState {
    updatingResponse: M.Generic.ItemLoadingState;
}

export class InvitationSummary extends Comp.Base.BaseComponent<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
            updatingResponse: {},
        };
    }

    public render() {

        return <div className="invitation-summary">
            <div className="flash">
                <div className="notice">
                    <h2>Congratulations!</h2>

                    <p>
                        The following abstract{this.props.abstracts.size === 1 ? " has" : "s have"} been accepted. Please accept or decline abstract placement.
                        Acceptance serves as your attestation to comply with the{" "}
                        <a href={Paths.Legacy.SpeakerGuidelines} target="_blank">Speaker Guidelines for Program Development</a>.
                    </p>

                    <ul className="invitation-summary-abstracts">
                        {this.props.abstracts.map((a: M.Abstract.Abstract, i) => {
                                const loading = !!this.state.updatingResponse[a.id];

                                return <li key={i}>
                                        <h3 dangerouslySetInnerHTML={{ __html: a.title }} />
                                        <p>
                                            {a.placementDisplay ? a.placementDisplay : Utility.joinSkipEmpty([a.placement, a.typeShortName], " ")}
                                        </p>
                                        <p>
                                        {a.scheduledOn.length
                                            ? a.scheduledOn.map((s, k) => {
                                                const start = Utility.fromApiDateAsMoment(s.startDateLocal);
                                                const end = Utility.fromApiDateAsMoment(s.endDateLocal);
                                                return <Comp.Generic.WrapperLess key={k}>
                                                {start.format("dddd, MMMM D")}, {DateHelper.displayTimeRange(start, end, "-")}
                                                </Comp.Generic.WrapperLess>;
                                            })
                                            : null
                                        }
                                        </p>
                                        {a.invitationDeadline
                                            ?
                                            <p className="mute">
                                                Respond by {Utility.utcToLocalAsMoment(a.invitationDeadline || "").format("MMMM D")}
                                            </p>
                                            : null
                                        }

                                        {loading
                                            ? <BS.Button bsStyle="default"><Comp.Generic.LoadingIcon /> Updating response&hellip;</BS.Button>
                                            : <BS.ButtonGroup>
                                                <BS.Button
                                                    bsStyle={a.invitationResponseId === M.Abstract.InvitationResponse.Accepted.id ? "primary" : "default"}
                                                    onClick={() => this.updateInvitationResponse(a, M.Abstract.InvitationResponse.Accepted.id)}
                                                >
                                                    Accept
                                                </BS.Button>
                                                <BS.Button
                                                    bsStyle={a.invitationResponseId === M.Abstract.InvitationResponse.Declined.id ? "primary" : "default"}
                                                    onClick={() => this.updateInvitationResponse(a, M.Abstract.InvitationResponse.Declined.id)}
                                                >
                                                    Decline
                                                </BS.Button>
                                            </BS.ButtonGroup>}
                                    </li>;
                            })}
                    </ul>

                    {this.props.event.abstractSettings
                        ? <div dangerouslySetInnerHTML={{ __html: this.props.event.abstractSettings.invitationNotes || ""}} />
                        : null}
                </div>
            </div>
        </div>;
    }

    private async updateInvitationResponse(a: M.Abstract.Abstract, invitationResponseId: number) {
        if (!!this.state.updatingResponse[a.id])
            return;

        await this.updateResponseLoading(a.id, true);

        const result = await this.props.api.post(Api.endpoints.abstract.invitationResponse.withUrlParams({ guid: a.guid }), {
            body: JSON.stringify({
                invitationResponseId,
            }),
        });

        await this.updateResponseLoading(a.id, false);

        if (result.isSuccess)
            this.props.onResponseUpdated(a, invitationResponseId);
        else
            this.props.onUpdateFailed(a, M.Result.Result.errorsOrMessage(result));
    }

    private async updateResponseLoading(abstractId: number, loading: boolean) {
        const updatingResponse = { ...this.state.updatingResponse };
        updatingResponse[abstractId] = loading;
        await this.setStateAsync({ ...this.state, updatingResponse });
    }
}



// WEBPACK FOOTER //
// ./src/containers/user/abstracts/components/InvitationSummary.tsx